const bootstrap = window.__BOOTSTRAP__;

delete window.__BOOTSTRAP__;

export const getBootstrap = () => bootstrap;

export const updateBootstrap = (key, value) => (bootstrap[key] = value);
